
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M19.5 7C20.8807 7 22 5.88071 22 4.5C22 3.11929 20.8807 2 19.5 2C18.2905 2 17.2816 2.85888 17.05 4H7.05C6.20002 4 4.98979 4.27162 3.96405 4.95545C2.89743 5.66653 2 6.85421 2 8.6C2 10.4045 2.95755 11.6085 4.06481 12.31C4.53133 12.6056 5.14915 12.467 5.44473 12.0005C5.74031 11.534 5.60174 10.9162 5.13521 10.6206C4.47996 10.2054 4 9.5816 4 8.6C4 7.64579 4.45257 7.03347 5.07345 6.61955C5.7352 6.17838 6.54998 6 7.05 6H17.4C17.4325 6 17.4647 5.99845 17.4964 5.99541C17.9523 6.60525 18.68 7 19.5 7Z"></path><path d="M18.9927 12.5719C19.3396 12.1421 19.9692 12.0749 20.3989 12.4218C21.3072 13.1549 22 14.2694 22 15.8C22 17.5458 21.1026 18.7335 20.0359 19.4445C19.0102 20.1284 17.8 20.4 16.95 20.4H7.8331C7.47179 21.336 6.56344 22 5.5 22C4.11929 22 3 20.8807 3 19.5C3 18.1193 4.11929 17 5.5 17C6.486 17 7.33868 17.5708 7.74562 18.4H16.95C17.45 18.4 18.2648 18.2216 18.9265 17.7804C19.5474 17.3665 20 16.7542 20 15.8C20 14.9479 19.6414 14.3806 19.1428 13.9781C18.713 13.6312 18.6458 13.0016 18.9927 12.5719Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.17674 10.0028L9.30901 9.26454L7.83252 9L7.70025 9.73824L7.13225 12.9085L7 13.6466L7.73812 13.779L10.9084 14.3474L11.6466 14.4798L11.9113 13.0034L11.1731 12.871L9.69372 12.6057C10.5108 12.162 11.4331 11.9233 12.3794 11.9233C13.8713 11.9233 15.3035 12.5166 16.358 13.5711L17.4187 12.5105C16.0828 11.1746 14.2691 10.4233 12.3794 10.4233C11.1674 10.4233 9.98663 10.7324 8.94315 11.3065L9.17674 10.0028Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowworkflowRevokeFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
